import React from 'react';
import { Flex, Box } from '@chakra-ui/react';
import LinksSidebar from './LinksSidebar';

const ContentWithStickySidebar = ({
  children,
}: {
  children: React.ReactNode;
}) => (
  <Flex direction={['column', 'row']} maxW="4xl" mx="auto" py="12" px="5">
    <Box>{children}</Box>
    <LinksSidebar
      alignSelf="start"
      position="sticky"
      top="200"
      ml={['0', '9']}
      minW="52"
      py={['24', '0']}
    />
  </Flex>
);

export default ContentWithStickySidebar;
